import { render } from "./DatabaseTaskConfigurationView.vue?vue&type=template&id=291be4bd&scoped=true&ts=true"
import script from "./DatabaseTaskConfigurationView.vue?vue&type=script&lang=ts"
export * from "./DatabaseTaskConfigurationView.vue?vue&type=script&lang=ts"

import "./DatabaseTaskConfigurationView.vue?vue&type=style&index=0&id=291be4bd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291be4bd"]])

export default __exports__